import { Component, Output, EventEmitter } from '@angular/core';
import { GlobalSearchTableViewComponent } from '../global-search-table-view/global-search-table-view.component';
import { TableView } from '../../ui/filterable-table/tableView';
import { GlobalSearchRecord } from '../../../models/search/GlobalSearchRecord';
import { Merchant } from '../../../models/merchant/merchant';
import { MerchantService } from '../../../models/merchant/merchantService';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TransactionService } from '../../../models/transactions/transactionService';
import { AccountService } from '../../../models/account/accountService';
import { UserService } from '../../../models/users/userService';
import { CustomerService } from '../../../models/customer/customerService';
import { Customer } from '../../../models/customer/customer';
import { Account } from '../../../models/account/account';
import { UIErrorHandler } from '../../../core/uiErrorHandler';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  standalone: false,
})
export class GlobalSearchComponent {
  @Output() checkRecordDetailsIsVisible = new EventEmitter<boolean>();

  tableView: any;
  searchTableOptions: any = {
    queryOnLoad: false,
  };

  viewingDetails: boolean = false;
  selectedMerchant: Merchant | undefined;
  selectedTransaction: TransactionFacade | undefined;
  selectedCustomer: Customer | undefined;
  selectedAccount: Account | undefined;

  constructor(
    private merchantService: MerchantService,
    private transactionService: TransactionService,
    private accountService: AccountService,
    private userService: UserService,
    private customerService: CustomerService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    this.tableView = new TableView(GlobalSearchTableViewComponent);
  }

  handleRecordSelected(record: GlobalSearchRecord) {
    this.clearSelectedDetails();

    switch (record.type) {
      case 'business':
        this.loadSelectedAccountDetails(record.id);
        break;

      case 'customer':
        this.loadSelectedCustomerDetails(record.id);
        break;

      case 'merchant':
        this.loadSelectedMerchantDetails(record.id);
        break;

      case 'transaction':
        this.loadSelectedTransactionDetails(record.id);
        break;

      case 'user':
        this.loadSelectedUserDetails(record.id);
        break;

      default:
        this.viewingDetails = false;

        return;
    }

    this.viewingDetails = true;
    this.checkRecordDetailsIsVisible.emit(true);
  }

  btnCloseDetails_click() {
    this.clearSelectedDetails();
    this.viewingDetails = false;
    this.checkRecordDetailsIsVisible.emit(false);
  }

  private clearSelectedDetails() {
    this.selectedMerchant = undefined;
    this.selectedTransaction = undefined;
    this.selectedCustomer = undefined;
    this.selectedAccount = undefined;
  }

  private loadSelectedAccountDetails(recordId: string) {
    this.accountService
      .getAccount(recordId)
      .then((account) => {
        this.selectedAccount = account;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedCustomerDetails(recordId: string) {
    this.customerService
      .getCustomerById(recordId)
      .then((customer) => {
        this.selectedCustomer = customer;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedMerchantDetails(recordId: string) {
    this.merchantService
      .getMerchantById(recordId)
      .then((merchant) => {
        this.selectedMerchant = merchant;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedTransactionDetails(recordId: string) {
    this.transactionService
      .getTransaction(recordId)
      .then((trans) => {
        this.selectedTransaction = trans;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  private loadSelectedUserDetails(recordId: string) {}
}
